import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import {
  RightOutlined,
  LoadingOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
  InfoCircleFilled,
} from '@ant-design/icons';
import { Image, Modal, Popover, Tooltip, Spin } from 'antd';

import { bomUpload, bomUploadCheck } from '../header-http';

import { getBomPopoverAd } from '@lcsc-ui/apis/op';
import SvgIcon from '@lcsc-ui/components/SvgIcon';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import Utils from '@lcsc-ui/utils/Utils';

// 埋点
function bomBuried(op) {
  buriedPoint({
    ty: 'click',
    cp: 'bom_upload_index',
    op,
  });
}

let fileDom = '';
let uploadTimes = 0;
let action = '';

function BomUploadPopover({ handleClick, handleChange, isIndexPage }) {
  const [adLoading, setAdLoading] = useState(false);
  const [adInfo, setAdInfo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setAdLoading(true);
        const res = await getBomPopoverAd();
        if (res && res.result) {
          setAdInfo(res.result);
        } else {
          setAdInfo(null);
        }
      } catch (error) {
        console.error('getBomPopoverAd', error);
        setAdLoading(false);
      } finally {
        setAdLoading(false);
      }
    };

    fetchData();
  }, []);

  function downLoadBomTemp() {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'BOM_upload',
      op: 'download_model',
    });
    window.open(Domains.lcscBomUrl + '/bom/template', '_blank');
  }

  function handleBuriedPoint(event, op) {
    event.stopPropagation();
    if (isIndexPage) {
      buriedPoint({
        pf: 'pc',
        ty: 'click',
        cp: 'bom_upload_index',
        op,
      });
    }
  }

  return (
    <div className="relative">
      <Spin indicator={<LoadingOutlined />} size="small" spinning={adLoading}>
        {adInfo ? (
          <a
            onClick={(e) => handleBuriedPoint(e, 'blank_space')}
            href={adInfo?.targetLink}
            ignore-spm
            target="_blank"
            style={{
              background: `url(${adInfo?.advertisingUrl}) no-repeat center / 100% 254px`,
            }}
            className="block bg-gradient-to-b from-[#fff] to-[#EDF9FF] h-[254px] w-full rounded-t-[8px]"
          ></a>
        ) : (
          <a
            onClick={(e) => handleBuriedPoint(e, 'blank_space')}
            href={Domains.lcscBomUrl + '/bom.html'}
            target="_blank"
            data-spm="bom2"
            className="via-purple block h-[254px] rounded-t-[8px] bg-gradient-to-b from-[#fff] to-[#EDF9FF] pl-[35px] pt-[40px] hover:text-black"
          >
            <p className="text-lcBlue text-[20px] font-bold leading-[22px]">标品配齐，选立创BOM配单</p>
            <ul className="mt-[10px] flex items-center text-[16px]">
              <li className="mr-[6px]">智能匹配</li>
              <li className="mr-[6px]">·</li>
              <li className="mr-[6px]">在线编辑</li>
              <li className="mr-[6px]">·</li>
              <li className="mr-[6px]">分享同事</li>
              <li className="mr-[6px]">·</li>
              <li className="mr-[6px]">下单协作</li>
            </ul>
            <span
              onClick={(e) => handleBuriedPoint(e, 'learn_more')}
              className="text-lcBlue mt-[3px] block text-[14px] leading-[22px]"
            >
              了解更多
              <RightOutlined />
            </span>
            <div className="absolute right-0 top-0">
              <Image
                src="https://static.szlcsc.com/ecp/assets/newWeb/header/bom-popover-bg.svg"
                alt="BOM配单"
                width={251}
                height={208}
                preview={false}
              ></Image>
            </div>
          </a>
        )}
      </Spin>
      <div className="absolute left-[15px] top-[153px] h-[170px] w-[569px] rounded-[4px] border border-solid border-[#CFF0FF] bg-white text-center">
        <p className="mt-[50px] text-[18px] leading-[22px]">
          快速匹配 一键下单 最高优惠
          <span className="text-lcBlue font-bold">3000元</span>
        </p>
        <button
          type="primary"
          className="bg-lcBlue relative mx-auto mt-[17px] flex h-[32px] w-[116px] items-center rounded-[4px] text-center text-[14px] leading-[32px] text-white hover:bg-[#56B3EE]"
        >
          <input
            type="file"
            id="www-bom-wrap-upload-file"
            className="absolute left-[0] top-[0] h-full w-full cursor-pointer text-[0] opacity-[0]"
            onClick={(e) => {
              handleClick(e, 'popover');
            }}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <UploadOutlined className="ml-[16px] mr-[5px]" />
          <span>上传BOM</span>
        </button>
      </div>
      <div className="mt-[77px] flex items-center justify-between px-[15px] pb-[16px]">
        <p className="text-[12px] leading-[22px] text-[#999]">
          支持多格式上传，如：xls、xlsx、csv、JPG、PNG、JPEG; 最大文件不能超过10M
        </p>
        <button onClick={downLoadBomTemp} className="text-lcBlue text-[12px]">
          模板下载
          <Tooltip title="使用商城模板匹配会提升匹配度">
            <ExclamationCircleOutlined className="ml-[4px]" />
          </Tooltip>
        </button>
      </div>
    </div>
  );
}

export default function BomUpload({
  resourceData,
  headBuriedPoint,
  isLg,
  notIndexHeaderAdapter,
  isFloat,
  onlySScreen,
}) {
  const isIndexPage = !notIndexHeaderAdapter;
  const { userInfo } = useUserStore();
  const logined = userInfo?.customerLogin === 1;
  const showBomIcon = (!isFloat && notIndexHeaderAdapter) || (!notIndexHeaderAdapter && isLg);
  // 上传BOM按钮相关
  const [isDragFile, setIsDragFile] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [loading, setLoading] = useState(false);
  const btnRef = useRef(null);

  function click(e, type) {
    // 触发点击
    if (type === 'popover' && isIndexPage) {
      action = 'BOM_UPLOAD_FILES_BY_BUTTON';
    } else {
      action = 'upload_bom_files';
    }
  }

  function handleLogin(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    setIsDragFile(false);
    Utils.showWindowLogin();
  }

  function dragEnter() {
    action = 'drag_bom_files';
    setIsDragFile(true);
  }

  function dragLeave() {
    setIsDragFile(false);
  }

  async function change(e) {
    fileDom = e.target;
    const isLogin = await Utils.checkLogin();
    if (!isLogin) {
      Utils.showWindowLogin();
      return;
    }
    if (isDragFile) {
      headBuriedPoint('DRAG_BOM_FILES');
    } else {
      headBuriedPoint('BOM_UPLOAD_FILES');
    }
    setIsDragFile(false);
    uploadTimes = 1;
    preUpload();
  }

  function preUpload() {
    const file = fileDom?.value;
    if (file) {
      const nip = file.substring(file.lastIndexOf('.') + 1).toLowerCase();
      if ('[xls][xlsx][csv][JPG][PNG][JPEG][jpg][png][jpeg]'.indexOf('[' + nip + ']') < 0) {
        warning('您上传的BOM清单格式不准确，当前支持上传xls、xlsx、csv、JPG、PNG、JPEG格式，请检查后重新上传');
        return;
      }
      const maxsize = 10 * 1024 * 1024;
      const fileSize = fileDom?.files[0]?.size || 0;
      if (fileSize > maxsize) {
        warning('您上传的BOM文件超过10M，请检查后重新上传');
        return;
      }
      checkBom();
    }
  }

  function checkBom() {
    setLoading(true);
    const fd = new FormData();
    fd.append('bomFile', fileDom?.files[0]);
    bomUploadCheck(fd).then(successFn).catch(failureFn);
  }

  function upload() {
    setLoading(true);
    const fd = new FormData();
    fd.append('bomFile', fileDom?.files[0]);
    bomUpload(fd).then(successFn).catch(failureFn);
  }

  // 上传文件成功回
  function successFn({ code, msg, result, fileError }) {
    if (code === 200) {
      const isCheckPass = result?.checkPass;
      // 提示弹窗
      // 第一次上传，且超过限制条数，弹窗提示
      if (uploadTimes === 1 && !isCheckPass) {
        setLoading(false);
        Modal.confirm({
          title: 'BOM行数限制',
          icon: <InfoCircleFilled style={{ color: '#0052D9' }} />,
          content: `上传文件的行数已超过${result?.readRowMaxSize || 300}行，超出部分将无法被识别。请确认是否继续上传。`,
          okText: '继续上传',
          cancelText: '返回修改',
          width: 480,
          centered: true,
          onOk: () => {
            upload();
          },
        });
        uploadTimes = 2;
      }
      // 第一次上传，且不超过限制条数，直接继续上传
      else if (uploadTimes === 1 && isCheckPass) {
        uploadTimes = 2;
        upload();
      } else {
        setLoading(false);
        if (document.querySelector('#www-bom-upload-file')) {
          document.querySelector('#www-bom-upload-file').value = '';
        }
        if (document.querySelector('#www-bom-wrap-upload-file')) {
          document.querySelector('#www-bom-wrap-upload-file').value = '';
        }
        if (result.bomUuid) {
          bomBuried(action);
          let url = `${resourceData?.projectConfigVO?.lcscBomUrl}/member/bom/upload/${result.bomUuid}.html`;
          if (btnRef) {
            url = Utils.getBtnSpmQueryUrl(url, btnRef.current);
          }
          location.href = url;
        }
      }
    } else if (fileError || (code === 500 && msg)) {
      const message = fileError || msg;
      setLoading(false);
      warning(message);
    } else {
      setLoading(false);
      lcMsgTips.showConfirmModal({
        title: '无返回数据',
      });
    }
  }

  // 失败回调
  function failureFn(e) {
    setLoading(false);
    uploadTimes = 1;
    warning(e.msg);
  }

  function warning(message) {
    lcMsgTips.showConfirmModal({
      title: message,
    });
  }

  function BOMicon() {
    return <SvgIcon app="common" iconName="bom" className="h-[18px] w-[19px]" />;
  }
  let content = (
    <button
      className={`text-lcBlue relative flex h-[42px] cursor-pointer ${isFloat ? 'w-[103px]' : notIndexHeaderAdapter ? Utils.addBigScreenClassName('w-[112px]', '_lg:w-[140px]', onlySScreen) : Utils.addBigScreenClassName('w-[93px]', '_lg:w-[112px]', onlySScreen)} ml-[30px] items-center justify-center rounded-[10px] bg-[#EDF9FF] text-[14px] ${isDragFile ? 'border-[1px] border-dashed border-[#199FE9]' : ''} hover:border-[1px]  hover:border-solid  hover:border-[#199FE9]`}
      onClick={handleLogin}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleLogin}
      onDragEnter={() => {
        setIsDragFile(true);
      }}
      onDragLeave={() => {
        setIsDragFile(false);
      }}
    >
      {isDragFile ? (
        <span>释放鼠标上传</span>
      ) : (
        <>
          {showBomIcon && <BOMicon />}
          <span className="ml-[7px]">上传BOM</span>
        </>
      )}
    </button>
  );

  if (logined) {
    content = (
      <button
        className={`text-lcBlue relative flex h-[42px] ${isFloat ? 'w-[103px]' : notIndexHeaderAdapter ? Utils.addBigScreenClassName('w-[112px]', '_lg:w-[140px]', onlySScreen) : Utils.addBigScreenClassName('w-[93px]', '_lg:w-[112px]', onlySScreen)} ml-[30px] items-center justify-center rounded-[10px] bg-[#EDF9FF] text-[14px]
        ${isDragFile ? 'border-[1px] border-dashed border-[#199FE9]' : ''} ${isHover ? 'border-[1px] border-solid border-[#199FE9]' : ''}`}
        ref={btnRef}
        data-spm="bom"
      >
        <input
          type="file"
          id="www-bom-upload-file"
          className="absolute left-[0] top-[0] h-full w-full cursor-pointer text-[0] opacity-[0]"
          title=""
          onClick={(e) => {
            click(e);
          }}
          onDragEnter={(e) => {
            dragEnter(e);
          }}
          onDragLeave={(e) => {
            dragLeave(e);
          }}
          onChange={(e) => {
            change(e);
          }}
          onMouseEnter={() => {
            setIsHover(true);
          }}
          onMouseLeave={() => {
            setIsHover(false);
          }}
        />
        {isDragFile ? (
          <span>释放鼠标上传</span>
        ) : (
          <>
            {showBomIcon && <BOMicon />}
            <span className="ml-[7px]">上传BOM</span>
          </>
        )}
      </button>
    );
  }
  return (
    <>
      <Popover
        overlayClassName="lcsc-popover-wrapper"
        placement="bottomRight"
        overlayInnerStyle={{ maxHeight: '370px' }}
        overlayStyle={{
          width: '599px',
          height: '380px',
          zIndex: '999',
          paddingTop: '8px',
        }}
        content={
          <BomUploadPopover
            isIndexPage={isIndexPage}
            handleClick={logined ? click : handleLogin}
            handleChange={change}
          />
        }
        getPopupContainer={() => (isFloat ? document.getElementById('float-header') : document.body)}
      >
        {content}
      </Popover>
      <Loading isOpen={loading}></Loading>
    </>
  );
}

function Loading({ isOpen }) {
  if (!isOpen) return null;

  return createPortal(
    <div
      className={`fixed bottom-[0] left-[0] right-[0] top-[0] z-[9999] flex items-center justify-center bg-[rgba(0,0,0,0.35)]`}
    >
      <div className="h-[396px] w-[580px] rounded-[3px] bg-[white] pt-[24px] text-center text-[18px] text-[#315af8]">
        <Image
          src="https://static.szlcsc.com/ecp/assets/web/page/bom/bomIndex/images/loading.gif"
          alt="BOM配单分析中"
          width={510}
          height={292}
          preview={false}
          className="m-[0_auto_35]"
        ></Image>
        <div>BOM正在分析中...</div>
      </div>
    </div>,
    document.body
  );
}
